import { useDispatch, useSelector } from 'react-redux';

import * as dealLockingActionCreators from '@makemydeal/dr-dash-store/actions/dealLockingActionCreators';
import * as dealLockingSelectors from '@makemydeal/dr-dash-store/selectors/dealLockingSelectors';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { getQuoteMode } from '@makemydeal/dr-dash-store/selectors/quoteSelectors';
import type { OfferTypeMode } from '@makemydeal/dr-shared-types';

import { dealLockHooks } from '../hooks';

export const useLockDeal = () => {
    const isLockSupported = useSelector(dealLockingSelectors.isLockSupported);
    const isLocked = useSelector(dealLockingSelectors.getLockPaymentInputsInSVByDealType);
    const offerType = useSelector(offerReduxSelectors.getCurrentOfferType);
    const dispatch = useDispatch();
    const isDealLocked = dealLockHooks.useIsDealLocked();
    const isQuoteMode = useSelector(getQuoteMode);

    const toggleLock = () => {
        const newLockedState = !isLocked;
        dispatch(dealLockingActionCreators.setLockPaymentInputsInSV(offerType as OfferTypeMode, newLockedState));
        dispatch(dealLockingActionCreators.lockPaymentInputsClicked(newLockedState));
    };

    return {
        isLockSupported,
        isLocked,
        isDisabled: isDealLocked || isQuoteMode,
        toggleLock
    };
};
